import * as React from 'react';

import { useEnterpriseSelfServePrice } from '@coursera-web/wes-common';
import { first } from 'lodash';

import prices from 'js/lib/prices';

import { useNativeData, useNativeDataContext } from 'bundles/ent-website/components/NativeDataContext';

// TODO: This is a temporary solution to get the price to display correctly.
// We should consider locale as in the <ReactPriceDisplay /> component.
function prettifyPrice(price: string) {
  const numericPrice = Number(price);
  const prettyPrice = numericPrice % 1 === 0 ? numericPrice.toFixed(0) : numericPrice.toFixed(2);
  return prettyPrice;
}

function TeamsUnitPriceDataSource() {
  const { setNativeData } = useNativeDataContext();
  const nativeData = useNativeData('promo');

  const { productPrice } = useEnterpriseSelfServePrice({
    learnerCount: 1,
    billingType: 1,
    enterprisePromotionId: nativeData?.enterprisePromotion?.id,
  });

  const unitPrice = first(productPrice)?.actualLocalAmountTotal;
  const currencyCode = first(productPrice)?.currencyCode || 'USD';

  React.useEffect(() => {
    if (!nativeData) return;

    setNativeData('teamsUnitPrice', {
      unitPrice,
      currencyCode,
      currencySymbol: prices.getSymbolFromCurrency(currencyCode),
      prettyPrice: unitPrice ? prettifyPrice(unitPrice) : undefined,
    });
  }, [setNativeData, unitPrice, currencyCode, nativeData]);

  return null;
}

export default TeamsUnitPriceDataSource;
